import { render } from "./_fancy-title.vue?vue&type=template&id=0170e0a0"
import script from "./_fancy-title.vue?vue&type=script&lang=js"
export * from "./_fancy-title.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__